import LoadingSpinner from "../../../../../components/LoadingSpinner/LoadingSpinner";
import Modal from "../../../../../components/Modal/Modal";
import Button, { ButtonType } from "../../../../../components/Button/Button";
import { Wrapper } from "../../../../../components/styled/styled-components";
import Icon from "../../../../../components/Icon/icon";

interface Props {
  callSplitService: () => void;
  hideModal: () => void;
  loading?: boolean;
}

const TimedOutModal = ({ callSplitService, hideModal, loading }: Props) => (
  <Modal>
    <div className="timed-out-modal">
      <div>
        <Icon name="ExclamationSquare" iconWidth="2rem" />
      </div>
      <p>Stock has been released.</p>
      {loading ? (
        <Wrapper>
          <LoadingSpinner />
        </Wrapper>
      ) : (
        <>
          <Button type={ButtonType.primary} onClick={() => callSplitService()}>
            Recheck stock
          </Button>
          <Button
            type={ButtonType.secondary}
            style={{ marginTop: "10px" }}
            onClick={() => {
              hideModal();
            }}
          >
            Cancel
          </Button>
        </>
      )}
    </div>
  </Modal>
);

export default TimedOutModal;
